import { useState } from "react";
import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, DialogContent } from "@mui/material";

interface Message {
  user: string;
  text: string;
  time: string;
}

interface GroupData {
  messages?: Message[];
}

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  selectedGroup: GroupData | null;
}

export default function ViewChatModal({
  open,
  onClose,
  setOpen,
  selectedGroup,
}: ModalProps) {
  return (
    <Modal  
      className="modal addNotification_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          {/* Modal Header */}
          <div className="modal_title">
            <h2>Group Chat</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>

          {/* Chat Content */}
          <DialogContent>
            {selectedGroup?.messages && selectedGroup.messages.length > 0 ? (
              selectedGroup.messages.map((msg: Message, index: number) => (
                <div
                  key={index}
                  style={{
                    marginBottom: "15px",
                    padding: "10px",
                    borderRadius: "10px",
                    background: "#f5f5f5",
                  }}
                >
                  <b>{msg.user}</b>
                  <p style={{ margin: "5px 0" }}>{msg.text}</p>
                  <small style={{ opacity: 0.6 }}>{msg.time}</small>
                </div>
              ))
            ) : (
              <p>No messages available.</p>
            )}
          </DialogContent>
        </div>
      </div>
    </Modal>
  );
}
